import { ContentItem, ListItem, NodeIndex } from './types'
import { NodeType } from 'shared/types/ingestion'
import { getCorrectedTitle } from './utility'

export function convertContentTreeToList(
  grade: number,
  unitLists: ContentItem[],
) {
  const indexes = {
    grade,
    [NodeType.Unit]: 0,
    [NodeType.LessonPlan]: 0,
    [NodeType.Activity]: 0,
  }

  const contentItemToListItem = ({
    node,
    children,
  }: ContentItem): ListItem[] => {
    switch (node.type) {
      case NodeType.Unit: {
        indexes[NodeType.Unit]++
        indexes[NodeType.LessonPlan] = 0
        indexes[NodeType.Activity] = 0
        break
      }
      case NodeType.LessonPlan: {
        indexes[NodeType.LessonPlan]++
        indexes[NodeType.Activity] = 0
        break
      }
      case NodeType.Activity: {
        indexes[NodeType.Activity]++
      }
    }
    return [
      {
        node,
        correctedIndex: getCorrectedTitle(node, indexes),
        currentIndexes: indexString(indexes),
      },
      ...children.reduce<ListItem[]>((acc, item) => {
        return [...acc, ...contentItemToListItem(item)]
      }, []),
    ]
  }
  return unitLists.flatMap(contentItemToListItem)
}

function indexString(indexes: NodeIndex) {
  const parts: (keyof NodeIndex)[] = [
    NodeType.Unit,
    NodeType.LessonPlan,
    NodeType.Activity,
  ]
  return parts
    .reduce<string[]>((acc, part) => {
      if (indexes[part]) acc.push(`${part[0].toUpperCase()}:${indexes[part]}`)
      return acc
    }, [])
    .join(' ')
}
